import {
  periodColumnDefinition,
} from '../../../shared/columnDefinitions';
import columnDefs from '../../../shared/columnDefinitions/bookToTaxCodes';
import { Period } from '../../../shared/types';
import xlsxExport from '../../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { BookToTaxCode } from '../../clientAdministrationPage/types';

import { toastr } from 'react-redux-toastr';
import Config from '../../../config';

export default async ({
  periodName,
  entities,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}: {
  periodName: Period,
  entities: Omit<BookToTaxCode, 'periodName'>[],
  environmentSuffix: string,
  shouldDisplayZero: boolean,
  hideDecimals: boolean,
  negativeMinus: boolean,
}) => {
  const bookToTaxCodeDescriptionsWithPeriods = entities.map(entity => ({
    periodName,
    ...entity,
  }));

  const sheetData = [{
    name: 'Book to Tax Code Descriptions',
    type: SheetExportTypes.GRID,
    columnDefinitions: [
      periodColumnDefinition,
      ...columnDefs,
    ],
    data: bookToTaxCodeDescriptionsWithPeriods,
    options: {
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
    },
  }];

  try {
    await xlsxExport({
      sheetData: sheetData as any,
      metadata: {
        fileName: `TLS_Book_To_Tax_Codes_${periodName}${environmentSuffix}`,
        disableHeaderRendering: true,
      },
    });
  } catch (error) {
    toastr.error('', 'Exporting data to the excel file failed', Config.defaultToastrSettings);
  }
};
